<template>
  <div>
    <div
      class="
        banner
        d-flex
        flex-column
        justify-content-center
        align-items-center
      "
      style="background-color: #1041a5"
    >
      <h1 class="mt-5 font-weight-light display-4">
        {{ JobDesp.JobPositionName }}
      </h1>
      <div>
        <span><i class="fas fa-building"></i> CSI Group</span>

        <!-- Salary -->
      </div>

      <router-link
        :to="{ name: 'jobapply', params: { id: getJobPositionId } }"
        class="mt-5"
      >
        <button type="button" class="btn btn-lg btn-outline-light">
          Apply To Position
        </button>
      </router-link>

      <router-link
          :to="{ name: 'jobref', params: { id: getJobPositionId } }"
         style="margin-top: 5px; color: #fff; font-size: 13px">
          Or refer someone
        </router-link>

      <!-- <a
        href="/cclick/job/V6W3R38/refer"
        style="margin-top: 5px; color: #fff; font-size: 13px"
        >Or refer someone</a
      > -->
    </div>

    <!-- ----------------////////////////////////////////////////////////////----------------------- -->
    <div class="container mt-4 mb-5 px-xl-5">



      <span v-for="(matched, idx) in this.$router.options.routes" :key="idx">

        <router-link v-if="idx === 0" :to="{ name: 'home' }" style="color:#1041A5;text-decoration: none;">
          Job Openings
        </router-link>

        <span v-if="idx === 1" class="text-secondary"> {{ JobDesp.JobPositionName }}</span>
        <!-- <router-link v-if="idx === 1" :to="{ name: 'jobview', params: { id: getJobPositionId } }"
        style="color:#1041A5;text-decoration: none;">
         {{ JobDesp.JobDesHeader }}
        </router-link> -->
      

      <!-- <a v-if="idx <= this.$route.matched.length" :href="matched.path">
      {{ matched.name }} 
      </a> -->
      <span v-if="idx < 1"> > </span>
      </span>


      <!-- <div class="bg-blue-800 p-4">

      <span v-for="(matched, idx) in this.$route.matched"
      :key="idx">
      <a 
      :href="matched.path">
      {{ matched.name }}
      </a>
      <span v-if="idx != Object.keys(this.$route.matched).length - 1"> / </span>
      </span>

      </div>  -->
      <!-- <div>
        <a href="/cclick" style="color: #1041a5">Job Openings</a>
        <i
          class="fa fa-chevron-right text-secondary"
          style="font-size: 12px"
        ></i>
        <span class="text-secondary">RPA Developer - MTA</span>
      </div> -->


      <div class="mt-5">
      <h4>About the job {{JobDesp.JobPositionName}}</h4>
      <div v-html="getViewJobDescription"></div>
      </div>

      <!-- Package Details -->

      <div class="text-center mt-5 pb-4">
        <router-link
          :to="{ name: 'jobapply', params: { id: getJobPositionId } }"
          class="mt-5"
        >
          <button
            type="button"
            class="btn btn-lg btn-outline-secondary bg-primary-color"
            style="border-color: #1041a5; color: #fff"
          >
            Apply To Position
          </button>
        </router-link>

        <br />

        <router-link
          :to="{ name: 'jobref', params: { id: getJobPositionId } }"
          style="margin-top: 5px; color: #444; font-size: 13px">
          Or refer someone
        </router-link>
        <!-- <a
          href="/cclick/job/V6W3R38/refer"
          style="margin-top: 5px; color: #444; font-size: 13px"
          >Or refer someone</a
        > -->

        <br /><br /><br /><br />
        <div class="col-xs-4 m-1">
          <div class="dropdown dropup">
            <button
              class="btn btn-info btn-job dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Share
              <span class="caret"></span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <li>
                <a
                  href="https://www.facebook.com/sharer/sharer.php?u=https://www.careers-page.com/cclick/job/V6W3R38"
                  target="_blank"
                >
                  <button type="button" class="btn">
                    <img
                      src="https://manatal-backend-static.s3.amazonaws.com/static/career_page/img/theme_2/facebook.png"
                      height="20"
                      class="mx-1"
                    />
                    Facebook
                  </button>
                </a>
              </li>
              <li>
                <a
                  href="https://social-plugins.line.me/lineit/share?url=https://www.careers-page.com/cclick/job/V6W3R38"
                  target="_blank"
                >
                  <button type="button" class="btn">
                    <img
                      src="https://manatal-backend-static.s3.amazonaws.com/static/career_page/img/theme_2/line.png"
                      height="20"
                      class="mx-1"
                    />
                    Line
                  </button>
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://www.careers-page.com/cclick/job/V6W3R38&amp;title=.NET Programmer (RUBIX)"
                  target="_blank"
                >
                  <button type="button" class="btn">
                    <img
                      src="https://manatal-backend-static.s3.amazonaws.com/static/career_page/img/theme_2/linkedin.png"
                      height="20"
                      class="mx-1"
                    />
                    LinkedIn
                  </button>
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/intent/tweet?url=https://www.careers-page.com/cclick/job/V6W3R38"
                  target="_blank"
                >
                  <button type="button" class="btn">
                    <img
                      src="https://manatal-backend-static.s3.amazonaws.com/static/career_page/img/theme_2/twitter.png"
                      height="20"
                      class="mx-1"
                    />
                    Twitter
                  </button>
                </a>
              </li>
              <li>
                <a
                  href="https://api.whatsapp.com/send?text=.NET%20Programmer%20%28RUBIX%29%20https%3A//www.careers-page.com/cclick/job/V6W3R38"
                  target="_blank"
                >
                  <button type="button" class="btn">
                    <img
                      src="https://manatal-backend-static.s3.amazonaws.com/static/career_page/img/theme_2/whatsapp.png"
                      height="20"
                      class="mx-1"
                    />
                    Whatsapp
                  </button>
                </a>
              </li>
              <li>
                <a
                  href="mailto:?&amp;subject=Job: .NET Programmer (RUBIX)&amp;body=Hi there,%0D%0A %0D%0A I would like to share with you this job:%0D%0A %0D%0A https://www.careers-page.com/cclick/job/V6W3R38%0D%0A %0D%0A Best regards%0D%0A"
                >
                  <button type="button" class="btn">
                    <img
                      src="https://manatal-backend-static.s3.amazonaws.com/static/career_page/img/theme_2/mail.png"
                      height="20"
                      class="mx-1"
                    />
                    Email
                  </button>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import axios from "axios";
import variables from "@/variables";
import { useRoute } from "vue-router";


export default {
  setup() {
    const route = useRoute();

    return { route };
  },
  data() {
    return {
      JobDesp: [],
    };
  },
  created() {
    console.log(this.$route.params.id);
    axios
      .get(
        variables.API_URL +
          "position/GetViewJobDescription/" +
          this.$route.params.id
      )
      .then((response) => {
        this.JobDesp = response.data[0];
        document.title = this.JobDesp.JobPositionName + " CSI-GROUPS Open Position"
      })
      .catch((error) => {
        console.log(error);
      });
  },
  computed: {
    getViewJobDescription() {
      return this.JobDesp.JobDescription;
    },
    getJobPositionId() {
      return this.$route.params.id;
    },
    routes() {
      return this.$router.options.routes;
    }
  },
};
</script>

<style scoped>
.btn-info {
  color: #fff;
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.btn-info,
.btn-info:hover {
  background-color: #1041a5;
}
.bg-primary-color {
  background-color: #1041a5;
}

img,
video {
  max-width: 100%;
  height: 20px;
  display: inline-block;
  vertical-align: middle;
}
.banner {
  min-height: 56vh;
  padding-bottom: 20px;
  background: #546cb4;
  color: white;
  text-align: center;
  text-shadow: 1px 2px 3px rgb(0 0 0 / 50%);
}
</style>